import "./Content.scss";
import { useEffect, useState } from "react";

const Content = ({ img, left, title, content, id }) => {
  const [scrolled, setScrolled] = useState(false);

  const elementInViewport = (el) => {
    const rect = el.getBoundingClientRect();

    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      (rect.left <
        (window.innerWidth || document.documentElement.clientWidth)) &
        (rect.top <
          (window.innerHeight - window.innerHeight * 0.85 ||
            document.documentElement.clientHeight)) // -260 , -700
    );
  };

  useEffect(() => {
    const scrollEventHandler = () => {
      const el = document.getElementById(id);
      if (el !== null) {
        elementInViewport(el) && setScrolled(true);
      }
    };

    document.addEventListener("scroll", scrollEventHandler);
    return () => document.removeEventListener("scroll", scrollEventHandler);
  }, [id]);

  return (
    <article
      className={`content ${left ? "" : "content__reverse content--white"}`}
      id={id}
    >
      <div className="content__img-container">
        <img
          src={img}
          alt="information icon"
          loading="lazy"
          className={`content__img ${
            ""
            // title === "Why Reddit" ? "content__img--contain" : ""
          }`}
        />
      </div>
      <div className={`content__wrapper`}>
        <h3
          className={`about__subheader ${
            scrolled ? "content__subcontainer--animation" : ""
          }`}
        >
          {title}
        </h3>
        <div
          className={`content__subcontainer ${
            scrolled ? "content__subcontainer--animation" : ""
          } `}
        >
          {content}
        </div>
      </div>
    </article>
  );
};

export default Content;
